var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Grid, 
//Grow,
Typography, Popover,
//Typography,
 } from '@material-ui/core';
import { withSize } from 'react-sizeme';
import React, { Fragment, useMemo, useState, useCallback } from 'react';
import Icon from '@thingos/design-icons/web';
import { Tag } from './Tag';
export function TagList(_a) {
    var tags = _a.tags, onSelect = _a.onSelect, onDelete = _a.onDelete, rest = __rest(_a, ["tags", "onSelect", "onDelete"]);
    return (React.createElement(Grid, __assign({ container: true, direction: "row", spacing: 1 }, rest), tags.map(function (tag) { return (React.createElement(Grid, { item: true, key: tag.id },
        React.createElement(Tag, { onClick: onSelect != null ? function () { return onSelect(tag); } : undefined, onDelete: onDelete != null ? function () { return onDelete(tag); } : undefined },
            React.createElement(Typography, { variant: "body2" }, tag.name)))); })));
}
function TagRowWithCollapseMoreFC(_a) {
    var showMoreText = _a.showMoreText, size = _a.size, tags = _a.tags, onSelect = _a.onSelect, onDelete = _a.onDelete, rest = __rest(_a, ["showMoreText", "size", "tags", "onSelect", "onDelete"]);
    var displayedTags = useMemo(function () {
        var _a;
        if (tags.length === 1) {
            return tags;
        }
        if (size.width != null) {
            var tagNames = tags.map(function (tag) { return tag.name; });
            var usedUp = 150;
            for (var i = 0; i < tagNames.length; i++) {
                var tagWidth = 50 + (((_a = tagNames[i]) === null || _a === void 0 ? void 0 : _a.length) || 1) * 10;
                if (usedUp + tagWidth > size.width) {
                    return tags.slice(0, i);
                }
                usedUp += tagWidth;
            }
        }
        return tags;
    }, [size, tags]);
    var _b = useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var showMore = useCallback(function (event) {
        setAnchorEl(event.currentTarget);
    }, [setAnchorEl]);
    var handleClose = useCallback(function () {
        setAnchorEl(null);
    }, [setAnchorEl]);
    var open = Boolean(anchorEl);
    var id = open ? 'more-tags-popover' : undefined;
    var more = useMemo(function () { return tags.slice(displayedTags.length, tags.length); }, [displayedTags, tags]);
    var hasMore = useMemo(function () { return more.length > 0; }, [more]);
    return (React.createElement(Grid, { container: true, direction: "row", spacing: 1, style: rest.style },
        React.createElement(Grid, { item: true },
            React.createElement(Grid, __assign({ container: true, direction: "row", spacing: 1 }, rest), displayedTags.map(function (tag) { return (React.createElement(Grid, { item: true, key: tag.id },
                React.createElement(Tag, { onClick: onSelect != null ? function () { return onSelect(tag); } : undefined, onDelete: onDelete != null ? function () { return onDelete(tag); } : undefined },
                    React.createElement(Typography, { variant: "body2" }, tag.name)))); }))),
        hasMore && (React.createElement(Fragment, null,
            React.createElement(Grid, { item: true },
                React.createElement(Tag, { onClick: showMore },
                    React.createElement(Typography, { variant: "body2", noWrap: true }, showMoreText(more.length)),
                    React.createElement(Icon, { kind: "ui/arrowDown", height: "20", width: "20" }))),
            React.createElement(Popover, { id: id, open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                } },
                React.createElement("div", { style: { padding: 20 } },
                    React.createElement(TagList, { onSelect: onSelect, onDelete: onDelete, tags: more })))))));
}
export var TagRowWithCollapseMore = withSize()(TagRowWithCollapseMoreFC);
